import React from 'react';
import { Link } from 'react-scroll';
import logo from "../../images/Anis Ayser.png";

const Header = () => {

    return (
        <div className='bg-base-100/50 backdrop-blur-md sticky top-0 z-40 w-full border-b border-[#0c0c0f9d]'>
            <div className="navbar container mx-auto">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            <Link activeClass="active" to="home" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={-50} duration={500}>
                                Hero
                            </Link>
                            <Link activeClass="active" to="about" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={-50} duration={500}>
                                About
                            </Link>
                            <Link activeClass="active" to="service" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                                Service
                            </Link>
                            <Link activeClass="active" to="portfolio" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                                Portfolio
                            </Link>
                            <Link activeClass="active" to="skills" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                                Skills
                            </Link>
                            <Link activeClass="active" to="testimonials" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                                Testimonials
                            </Link>
                            <Link activeClass="active" to="contact" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                                Contact
                            </Link>
                        </ul>
                    </div>
                    <div>
                        <img src={logo} className="w-28" alt="" />
                    </div>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0">
                        {/* <li><a href='#home' className='bg-[#1F1912]'>Home</a></li> */}
                        <Link activeClass="active" to="home" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={-50} duration={500}>
                            Hero
                        </Link>
                        <Link activeClass="active" to="about" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={-50} duration={500}>
                            About
                        </Link>
                        <Link activeClass="active" to="service" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Service
                        </Link>
                        <Link activeClass="active" to="portfolio" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Portfolio
                        </Link>
                        <Link activeClass="active" to="skills" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Skills
                        </Link>
                        <Link activeClass="active" to="testimonials" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Testimonials
                        </Link>
                        <Link activeClass="active" to="contact" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Contact
                        </Link>
                    </ul>
                </div>
                <div className="navbar-end">
                    {/* <Link to='portfolio' className="btn" spy={true} smooth={true} offset={50} duration={500}>Projects</Link> */}
                    {/* <Link to='/' className="btn">Projects</Link> */}

                    {/* The button to open modal MODAL BODY IN ON THE BANNER COMPONENT*/}
                    <label htmlFor="my-modal-5" className="btn">View Resume</label>




                </div>
            </div>
        </div>
    );
};

export default Header;